import { useQuery } from "@tanstack/react-query";
import { getContentItem } from "../api/content.api";
import { ContentRow } from "../api/content.type";

function useLoadContentByIdOrSlug(
  idOrSlug: string,
  options?: { enabled?: boolean }
) {
  const { enabled = true } = options || {};

  const {
    data: content,
    isLoading,
    error,
  } = useQuery<ContentRow>({
    queryKey: ["content", idOrSlug],
    queryFn: () => getContentItem(idOrSlug),
    enabled: enabled && !!idOrSlug,
  });

  return { content, isLoading, error };
}

export default useLoadContentByIdOrSlug;

